// @ts-nocheck
import { createTheme } from '@mui/material/styles';
import {
  primary,
  secondary,
  error,
  success,
  warning,
  info,
  normalText,
} from '../../common/Colors';

export function createModifiedTheme() {
  const emailExternalTheme = createTheme({
    palette: {
      primary,
      secondary,
      error,
      success,
      warning,
      info,
      normalText,
    },
    typography: {
      h4: {
        fontFamily: 'Barlow Semi Condensed, sans-serif',
        fontWeight: '600',
        fontSize: '24px',
      },
      h5: {
        fontFamily: 'Barlow Semi Condensed, sans-serif',
        fontWeight: '600',
      },
      h6: {
        fontFamily: 'Barlow Semi Condensed, sans-serif',
        fontWeight: '600',
      },
      subtitle1: {
        fontWeight: '500',
      },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: primary.textColor,
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: '24px',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-input': { color: '#fff' },
            textarea: {
              padding: '0!important',
            },
            '& .MuiInputBase-input:-webkit-autofill': {
              WebkitBoxShadow: '0 0 0 100px #233759 inset!important',
              WebkitTextFillColor: '#fff',
              caretColor: '#fff',
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: '#fff!important',
            transform: 'translate(14px, 16px) scale(1)!important',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            height: 'auto!important',
            padding: '16.5px 14px!important',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          shrink: {
            transform: 'translate(14px, -9px) scale(0.75)!important',
          },
        },
      },
    },
  });

  return emailExternalTheme;
}
